import { transferOrderFileIdFormat } from "@redotech/redo-inventory-id";
import * as z from "zod";

export const deleteTransferFile = {
  name: "deleteTransferFile" as const,
  input: z.object({ fileId: transferOrderFileIdFormat.schema }),
  output: z.object({ success: z.boolean() }),
};
